import { useEffect, useRef, useState } from 'react';
import { Sprite, Container, Text } from 'react-pixi-fiber';
import * as PIXI from "pixi.js";
// import { gsap, absoluteCoords, wait } from '../../../utils';

function Ranged({ value, ready, scale, data, standard }) {
  const isGod = data.type == "Summoner"
  const containerRef = useRef();
  const [width, setWidth] = useState(null)
  // const [height, setHeight] = useState(null)
  // const [fontColor, setFontColor] = useState("white")

  useEffect(() => {
    if (ready) {
      let sampleCard = standard ? PIXI.utils.TextureCache["standard-silver-1"] : PIXI.utils.TextureCache["tactical-silver-1"]
      setWidth(sampleCard.width)
      // setHeight(sampleCard.height)
    }
  }, [ready])


  return (
    <Container ref={containerRef}>
      {value > 0 && (
        <>
          <Sprite 
            texture={PIXI.utils.TextureCache["ranged"]} 
            x={-width*0.92}
            y={0}
            anchor={{ x: 0.5, y: 0.5 }}
            visible={true}
            scale={scale}
          />
          <Text
            text={isGod ? (value > 0 ? `+${value}` : `${value}`) : value}
            anchor={{x: 0.5, y: 0.5 }}
            x={-width*0.92}
            y={0}
            style={{
              "fill": "white",
              fontFamily: "Almendra",
              fontStyle: "bold",
              fontSize: scale * 400
            }}
          />
        </>
      )}
    </Container>
  );
}

export default Ranged;
